import { $ } from '../vendors/jquery';

class PostArchive
{
    constructor( element ) 
    {
        this.element    = element;
        this.search     = this.element.find( '[data-element="post-archive-search"]' );
        this.categories = this.element.find( '[data-element="post-archive-term"]' );
        this.list       = this.element.find( '[data-element="post-archive-list"]' );
        this.load       = this.element.find( '[data-element="post-archive-load"]' );
        this.loader     = this.element.find( '[data-element="post-archive-loader"]' );
        this.button     = this.element.find( '[data-element="post-archive-button"]' );
        this.ajax       = mlpAsiaTheme.ajax; // eslint-disable-line

        this.itemHolder  = this.element.data( 'item-holder' );
        this.loadInitial = this.element.data( 'load-initial' );
        this.loadPage    = this.element.data( 'load-page' );
        this.page        = 2;
        this.postType    = this.element.data( 'post-type' );
        this.term        = 0;
        this.taxonomy    = null;
        this.hash        = $( window.location ).prop( 'hash' ).substr( 1 );

        this.init();
    }

    init() 
    {
        this.setSearchWithSelect2();
        this.search.on( 'select2:open', this.autoFocusInput.bind( this ) );
        this.search.on( 'change', this.onSearchChange.bind( this ) );
        this.button.on( 'click', this.onButtonClick.bind( this ) );

        if ( '' !== this.hash ) {
            this.filterSearch();
        }
    }

    setSearchWithSelect2() 
    {
        this.search.select2();
    }

    autoFocusInput() 
    {
        $( '.select2-search__field' )[0].focus();
    }

    onSearchChange() 
    {
        const $element = this.search.find( ':selected' );

        this.taxonomy = $element.data( 'taxonomy' );
        this.term     = $element.data( 'id' );
        this.page     = 1;

        this.setCategoriesInactive();
        $element.addClass( 'is-active' );
        this.clearItems();
        this.showLoad();
        this.loadItems();
    }

    filterSearch() 
    {
        const category = this.search.find( '[data-element="post-archive-term"][data-slug="' + this.hash + '"]' );

        if ( 0 === category.length ) {
            return;
        }

        this.search.val( category.data( 'id' ) );
        this.search.change();
    }

    setCategoriesInactive() 
    {
        this.categories.each( ( index, element ) => {
            $( element ).removeClass( 'is-active' );
        } );
    }

    onButtonClick() 
    {
        this.loadItems();
    }

    loadItems() 
    {
        this.showLoader();

        $.ajax( {
            data: {
                'action': 'archive_load_more',
                'item_holder': this.itemHolder,
                'load_initial': this.loadInitial,
                'load_page': this.loadPage,
                'nonce': this.ajax.nonce,
                'page': this.page,
                'post_type': this.postType,
                'taxonomy': this.taxonomy,
                'term': this.term
            },
            dataType: 'json',
            method: 'POST',
            url: this.ajax.url
        } ).done( (data) => {
            if (null !== data.html) {
                this.list.append( data.html );
            }

            if ( data.hideButton ) {
                this.hideLoad();
            }

            this.page++;
        } ).fail( (jqXHR) => {
            console.log(jqXHR);
        } ).always( () => {
            this.hideLoader();
        } );
    }

    clearItems() 
    {
        this.list.empty();
    }

    hideLoader() 
    {
        this.loader.addClass( 'd-none' );
    }

    showLoader() 
    {
        this.loader.removeClass( 'd-none' );
    }

    hideLoad() 
    {
        this.load.addClass( 'd-none' );
    }

    showLoad() 
    {
        this.load.removeClass( 'd-none' );
    }
}

const postArchive = {
    init() {
        const postArchiveElements = $( '[data-module="post-archive"]' );

        if ( null !== postArchiveElements && postArchiveElements.length > 0 ) {
            postArchiveElements.each( ( index, element ) => {
                new PostArchive( $( element ) );
            } );
        }
    }
};

export default postArchive;
